import * as React from 'react'
import { MessageActionListConnected } from './MessageActionListConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore, MOCK_MESSAGE_A_ID } from 'mockState'

export const MessageActionListExamples = () => {
  return (
    <div className="MessageActionListExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <MessageActionListConnected messageId={MOCK_MESSAGE_A_ID} />
      </Provider>
    </div>
  )
}
